var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSealTextHorizontal = function SvgSealTextHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195.917,
    height: 16.471,
    viewBox: "0 0 195.917 16.471",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 8.16) scale(34.65434)",
    spreadMethod: "pad",
    id: "lpLogo__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff322f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ff322f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e85d95",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e85d95",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ffce00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.011,
    y1: -0.035,
    x2: 1.011,
    y2: 0.035,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(176.077 27.421 4.767) scale(33.73229)",
    spreadMethod: "pad",
    id: "lpLogo__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4752be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4752be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#42bbfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42bbfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3cb678",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb678",
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M146.168 2.658a5.92 5.92 0 00-2.264.428 5.347 5.347 0 00-3.023 2.96 5.647 5.647 0 00-.428 2.218c0 .802.143 1.544.428 2.23a5.389 5.389 0 001.203 1.774 5.603 5.603 0 001.82 1.186 6.121 6.121 0 002.264.412c.823 0 1.583-.137 2.28-.412a5.426 5.426 0 001.804-1.187 5.389 5.389 0 001.203-1.774 5.574 5.574 0 00.443-2.23c0-.801-.147-1.541-.443-2.216a5.347 5.347 0 00-1.203-1.79 5.231 5.231 0 00-1.805-1.171 5.962 5.962 0 00-2.279-.428zm46.03 0c-.877 0-1.596.138-2.155.412-.56.264-.97.613-1.234 1.045a2.628 2.628 0 00-.397 1.393c0 .58.123 1.056.365 1.426.254.358.585.642.996.853.423.2.883.37 1.38.508.506.127 1.002.247 1.488.363.496.116.95.264 1.36.444.423.179.76.422 1.013.728.253.306.38.711.38 1.219 0 .433-.122.829-.365 1.187-.232.348-.595.63-1.092.84-.496.21-1.128.316-1.898.316-.76 0-1.474-.137-2.139-.412-.654-.285-1.16-.629-1.52-1.03l-.284.382c.38.442.929.811 1.646 1.106.728.285 1.5.428 2.313.428.886 0 1.613-.131 2.183-.396.58-.264 1.004-.613 1.268-1.045.274-.433.41-.897.41-1.393 0-.57-.126-1.027-.379-1.376a2.557 2.557 0 00-.998-.855 6.494 6.494 0 00-1.361-.506 38.446 38.446 0 00-1.489-.38 8.422 8.422 0 01-1.377-.444 2.632 2.632 0 01-.998-.727c-.253-.306-.378-.72-.378-1.236 0-.433.115-.83.347-1.188.232-.36.59-.642 1.076-.853.496-.222 1.115-.332 1.854-.332a5.49 5.49 0 011.55.236c.539.158 1.03.4 1.473.729l.237-.428c-.412-.306-.913-.55-1.504-.73a5.657 5.657 0 00-1.772-.284zm-127.14.037v11.082h8.122v-2.09h-5.557V2.696h-2.564zm15.557 0l-4.94 11.082h2.63l.988-2.375h5.135l.984 2.375h2.692L83.148 2.694zm10.508 0v2.09h5.953l-6.08 7.33v1.662h9.688v-2.09H94.38l6.066-7.33V2.695h-9.324zm12.123 0l4.29 7.13v3.952h2.564V9.854l4.306-7.16h-2.517l-2.967 4.919-2.953-4.918zm15.852.028v11.08h.539v-3.72h3.308c.918 0 1.703-.147 2.358-.442.665-.296 1.171-.72 1.52-1.268.348-.55.523-1.208.523-1.978s-.175-1.425-.524-1.963c-.348-.55-.854-.97-1.52-1.266-.654-.295-1.439-.443-2.357-.443zm11.113 0v11.08h.537v-3.72h3.309c.431 0 .833-.034 1.207-.1l2.736 3.82h.633l-2.838-3.94c.218-.061.426-.133.621-.221.665-.296 1.171-.72 1.52-1.268.348-.55.523-1.208.523-1.978s-.175-1.425-.523-1.963c-.349-.55-.855-.97-1.52-1.266-.654-.295-1.441-.443-2.36-.443h-3.845zm24.617 0v11.08h.522V3.841l4.875 8.425h.285l4.861-8.453.016 9.989h.521l-.015-11.08h-.444l-5.074 8.864-5.105-8.864zm15.133 0v11.08h.539v-3.72h3.309c.918 0 1.703-.147 2.357-.442.665-.296 1.171-.72 1.52-1.268.348-.55.523-1.208.523-1.978s-.175-1.425-.523-1.963c-.349-.55-.855-.97-1.52-1.266-.654-.295-1.44-.443-2.357-.443zm8.764 0v.49h4.068v10.59h.521V3.213h4.07v-.49h-8.66zm-32.557.427c.739 0 1.425.126 2.059.38a4.843 4.843 0 011.646 1.075 4.767 4.767 0 011.092 1.63 5.07 5.07 0 01.394 2.029c0 .738-.13 1.418-.394 2.04a4.807 4.807 0 01-1.092 1.615 4.843 4.843 0 01-1.646 1.076 5.504 5.504 0 01-2.059.382c-.728 0-1.41-.129-2.043-.38a5.014 5.014 0 01-1.662-1.078 5.138 5.138 0 01-1.092-1.614 5.363 5.363 0 01-.379-2.041c0-.74.126-1.416.38-2.028a5.088 5.088 0 011.09-1.63 5.014 5.014 0 011.663-1.077 5.451 5.451 0 012.043-.38zm-26.531.063h3.34c1.245 0 2.195.28 2.85.84.664.549.995 1.328.995 2.342 0 1.013-.33 1.8-.996 2.359-.654.56-1.604.838-2.85.838h-3.34v-6.38zm11.111 0h3.342c1.245 0 2.195.28 2.85.84.664.549.996 1.328.996 2.342 0 1.013-.332 1.8-.997 2.359-.654.56-1.604.838-2.85.838h-3.341v-6.38zm39.752 0h3.34c1.245 0 2.195.28 2.85.84.664.549.996 1.328.996 2.342 0 1.013-.332 1.8-.997 2.359-.654.56-1.604.838-2.85.838H170.5v-6.38zm-88.635 2l1.756 4.24h-3.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lpLogo__a)",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    d: "M15.725 4.911C12.502 1.385 5.788.932 3.248 5.328a5.744 5.744 0 002.1 7.84 5.728 5.728 0 004.355.575c2.414-.648 4.7-3.792 6.456-5.693l4.075-4.41C22.208 1.501 24.437.028 26.93-.075c3.23-.132 6.436 2.037 7.724 4.97-1.576-1.958-4.396-2.955-6.872-2.835-2.763.132-4.446 1.826-6.45 3.996L18.97 8.615l-2.415 2.613c-1.853 2.005-3.428 4.137-6.216 4.885-2.723.73-5.3.012-7.199-1.515C1.326 13.139.13 10.943.01 8.564-.289 2.562 5.892-1.622 11.34.621a8.181 8.181 0 014.385 4.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lpLogo__b)",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    d: "M39.932 11.489c3.223 3.526 9.937 3.98 12.477-.417a5.741 5.741 0 00-6.456-8.413c-2.413.647-4.699 3.79-6.455 5.693l-4.075 4.41c-1.974 2.136-4.204 3.61-6.696 3.712-3.23.133-6.436-2.036-7.724-4.97 1.576 1.958 4.397 2.956 6.872 2.837 2.763-.134 4.446-1.828 6.45-3.997l2.363-2.558L39.1 5.173c1.854-2.006 3.429-4.139 6.217-4.885 2.723-.73 5.3-.012 7.199 1.514 1.814 1.458 3.011 3.655 3.13 6.034.3 6.002-5.882 10.187-11.33 7.943a8.168 8.168 0 01-4.385-4.29"
  })));
};
export default SvgSealTextHorizontal;